/**
 * 受入 最終処分終了報告
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/receives/final_completions`

const order_receive_final_completion = {
  namespaced: true,
  actions: {
    /**
     * 最終処分終了報告 マニフェスト一覧取得
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    show ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 最終処分終了報告 一括登録
     * @param commit
     * @param params
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * 最終処分終了報告 個別登録
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit },{ params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default order_receive_final_completion

